import * as c from '../constants';
import { onWaiting, getMyUsers } from '../../Actions';
import _ from 'lodash';

export function isLoading(isLoading) {
    return {
        type: c.GRIPSIZE_LOADING,
        isLoading
    }
}


export const storeGripsize = (params) => {
    return (dispatch, getState, { api, alert, history }) => {
        dispatch(onWaiting(true));
        api.post('/gripsize', params, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return false;

                history.push("/billing/gripsize");
                if(_.isEmpty(params.username)) {
                    return history.push(`/billing/gripsize`);
                }
                history.push(`/billing/${params.username}/gripsize`);
            })
    }
}



export const getGripsize = (params) => {
    return (dispatch, getState, { api, alert }) => {
        let newParams = params;
        if(!_.isNil(params.username)) {
            const myUser = getMyUsers().filter(item => item.username === params.username);
            if(myUser.length > 0) {
                newParams['user_id'] = myUser[0].id;
                const noGripSize = {
                    user_id: myUser[0].id
                }
                dispatch({
                    type: c.GET_GRIPSIZE,
                    data: noGripSize
                });
            }
        }
        dispatch(onWaiting(true));
        api.get('/gripsize', newParams, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return false;
                if(!_.isNil(response.gripsize)) {
                    dispatch({
                        type: c.GET_GRIPSIZE,
                        data: response.gripsize
                })
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/gripsize/actions/index.js